import { Dispatch, FC, SetStateAction, useEffect, useState } from "react";
import { ErrorFallback } from "components";
import { StyledAlert, StyledAlertSuccessText } from "./Alert.styles";

type AlertProps = {
  alertType: "Success" | "Error";
  message: string;
  duration: number;
  isVisible: boolean;
  setIsAddSuccess: Dispatch<SetStateAction<boolean>>;
  setIsAddError: Dispatch<SetStateAction<boolean>>;
};

const Alert: FC<AlertProps> = ({
  alertType,
  message,
  duration,
  isVisible,
  setIsAddSuccess,
  setIsAddError,
}) => {
  const [visible, setVisible] = useState<boolean>(isVisible);

  const cleanState = () => {
    isVisible = false;
    setVisible(false);
    setIsAddSuccess(false);
    setIsAddError(false);
  };
  useEffect(() => {
    setTimeout(() => {
      cleanState();
    }, duration);

    return () => cleanState();
  }, [visible]);
  return (
    <StyledAlert alertType={alertType} isVisible={visible}>
      {alertType === "Error" && (
        <StyledAlertSuccessText>
          <ErrorFallback error={message} fontSize='16px' isWhite={true} />
        </StyledAlertSuccessText>
      )}

      {alertType === "Success" && (
        <StyledAlertSuccessText>{message}</StyledAlertSuccessText>
      )}
    </StyledAlert>
  );
};

export default Alert;
